/** Directive that marks content for projection into the left column of HxTwoColumnLayout. @directive */

import { Directive, input } from '@angular/core';

/** Marks content for left column projection via ng-content selector. Standalone with optional aria-label. */
@Directive({
  selector: '[hxTwoColumnLeft]',
  standalone: true,
  host: {
    '[attr.aria-label]': 'ariaLabel()',
  },
})
export class HxTwoColumnLeft {
  /** Optional ARIA label for left column (applied via host binding). */
  ariaLabel = input<string | undefined>();
}
